import Search from '@components/search/ProductSearch';
import {MediumDevice, SmallDevice} from '@ultradent/components';
import cx from 'classnames';
import User from '@modules/User';

import {classList} from '@containers/Reorder';
import {CommerceItemLists} from '@upi/data-layer-constants';
import {ReorderItemLookupAnalytics} from './analytics';

const ItemLookup = ( {pastPurchases, className} ) => {

    return (
        <div className={`bg-grey-lightest ${className}`}>

            <Search
                showAllSkus={User.isTamProxy()}
                pastPurchases={pastPurchases}
                itemList={CommerceItemLists.REORDER}>
                {( {isActive, query, queryGroups, resultGroups} ) =>
                    <div>
                    <ReorderItemLookupAnalytics
                        isActive={isActive}
                        query={query}
                        queryGroups={queryGroups}
                        resultGroups={resultGroups}/>
                    <div className="contain-content">
                        <div className="space-content py-4">
                            <h2 className={`hidden md:block ${classList.page.subheading}`}>Item Lookup</h2>
                            <div className="md:pb-8 md:mb-4">
                                <div className="max-w-md z-1 relative">
                                    <div id="sku-search--reorder">
                                        <div className="flex">
                                            <Search.Input/>
                                        </div>
                                        <MediumDevice>
                                            <Search.Results
                                                className={classList.search.results}
                                                noResultsClass="p-12 text-center text-xl"
                                                groupLabelClass={classList.search.groupLabel}>
                                                {results => <Search.ResultsPane>{results}</Search.ResultsPane>}
                                            </Search.Results>
                                        </MediumDevice>
                                    </div>
                                    <p className={cx(
                                        {hidden: isActive},
                                        'md:block max-w-sm leading-normal mt-8'
                                    )}>
                                        Find any item we offer with this simple lookup. You can lookup a specific item
                                        by its name or item #
                                    </p>
                                </div>
                            </div>
                        </div>
                        <SmallDevice className="flex flex-col">
                            <Search.Results groupLabelClass={classList.search.groupLabel}>
                                {results => <div>{results}</div>}
                            </Search.Results>
                        </SmallDevice>
                    </div>
                    </div>
                }
            </Search>

        </div>
    );
};

export default ItemLookup;
